module.exports = __webpack_public_path__ + "img/vip1.c3194f06.png";